import canUseMedia from './canUseMedia'

export default function isDesktop() {
  return canUseMedia && window.matchMedia('(min-width: 1200px)').matches
}
